<template>
    <div>
        <div class="tbfh">
            <div class="fjsf bit-center-wrap" @click="$nav.back()">
                <i class="el-icon-arrow-left" style="color: rgb(170, 170, 170);"></i>
                <span class="ted">
                    <font dir="auto" style="vertical-align: inherit;">
                        <font dir="auto" style="vertical-align: inherit;">{{ $t('充币') }}</font>
                    </font>
                </span>
            </div>
        </div>

        <div class="box">
            <div style="display: flex;justify-content: space-between;">
                <div class="content_TK bg-main">
                    <el-form label-position="top" label-width="80px" :model="form">
                        <el-form-item :label="$t('选择货币')">
                            <el-select v-model="form.payment_id" :placeholder="$t('请选择')" style="width: 100%;">
                                <el-option v-for="item in columns" :key="item.id" :label="item.name" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <div class="ewm_img">
                            <!-- <img src="https://shengge975.com/api/qrcode?text=undefined"
                                style="width: 160px; height: 160px;"> -->
                            <div id="qrcode" class="qrcode"></div>
                        </div>
                        <div class="bcewm cur-poi" @click="downloadImagesByParent"> {{ $t('保存二维码') }}</div>
                        <el-form-item label="充币地址">
                            <el-input v-model="form.address">
                                <template slot="suffix">
                                    <div class="dad" @click="copyText">{{ $t('复制') }}</div>
                                </template>
                            </el-input>
                        </el-form-item>
                        <!-- <span class="txt-14">{{ fileList }}</span> -->
                        <el-form-item :label="$t('上传充值凭证')">
                            <oUpload :fileList.sync="fileList" :limit="1" @preview="onPreview" />
                        </el-form-item>
                        <el-form-item :label="$t('充币数量')">
                            <el-input v-model="form.amount">
                            </el-input>
                        </el-form-item>
                    </el-form>

                    <div class="sdafasdf" @click="submit">{{ $t('充值') }}</div>
                </div>

                <div class="right">
                    <img src="@/assets/img-pc/change_7.png" />
                    <div class="tips-back">
                        <div class="flex-v-c">
                            <img src="@/assets/img-pc/change_8.png" class="notice-img" />
                            <span class="fsfs">
                                <font dir="auto" style="vertical-align: inherit;">
                                    <font dir="auto" style="vertical-align: inherit;">{{ $t('重要通知') }}</font>
                                </font>
                            </span>
                        </div>
                        <div class="content" v-html="richtext">
                        </div>
                    </div>
                </div>
            </div>
            <div class="infosty bg-main">
                <div class="titlesty">
                    <font dir="auto" style="vertical-align: inherit;">
                        <font dir="auto" style="vertical-align: inherit;">{{ $t('充值记录') }}</font>
                    </font>
                </div>

                <div class="MetaTrader5-bottom-content">
                    <div class="trend-head">
                        <div class="column">{{ $t('币种') }}</div>
                        <div class="column">{{ $t('充值数量') }}</div>
                        <div class="column">{{ $t('状态') }}</div>
                        <div class="column">{{ $t('创建时间') }}</div>
                    </div>
                    <div class="scroll-wrap">
                        <ul class="trend-body">
                            <li class="row" v-for="item in list" :key="item.id">
                                <div class="column">{{ item.payment_name }}</div>
                                <div class="column">{{ item.amount }}</div>
                                <div class="column">{{ item.status_text }}</div>
                                <div class="column">{{ item.createtime_text }}</div>
                            </li>
                        </ul>
                    </div>

                    <oPage v-if="page.total > page.limit" :current-page.sync="page.page" :page-size.sync="page.limit"
                        :total="page.total" @current-change="recharge" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import oPage from '@/common/pc/oPage.vue'
import oUpload from '@/common/pc/oUpload.vue'
import { get, post } from '@/http/request'
import apis from '@/http/api'
import QRCode from 'qrcodejs2';

const qrcodeID = 'qrcode'
export default {
    components: {
        oPage,
        oUpload
    },
    data() {
        return {
            columns: [],

            richtext: '',
            list: [],

            fileList: [], // 存放上传的图片 

            form: {
                amount: '',
                payment_id: '',
                address: '',
            },

            page: {
                page: 1,
                limit: 10,
                total: 100,
            }
        };
    },
    watch: {
        "form.payment_id"(id) {
            if (!Array.isArray(this.columns)) return
            let paymen = this.columns.filter(item => item.id == id)[0]
            // console.log(paymen.rate)
            this.form.address = paymen.address
            this.qRCodeS()
        },
    },
    mounted() {
        this.getData()
        this.recharge()
    },
    beforeUnmount() { },
    methods: {
        onPreview(file) {
            console.log("preview", file);
        },
        async getData() {
            const res = await get(apis.getData, { showLoading: false })
            if (res.code == 1) {
                // console.log(res.data, '444');
                this.richtext = res.data.richtext
                this.columns = res.data.payment

                if (this.columns.length > 0) {
                    this.form.address = this.columns[0].address
                    this.form.payment_id = this.columns[0].id
                }
                // this.qRCodeS()
            }
        },
        //充值记录
        async recharge() {
            const res = await get(apis.rechargeList, { ...this.page })
            if (res.code == 1) {
                this.list = res.data.data
                this.page.total = res.data.total
            }
        },
        //充值提交
        async submit() {
            if (this.fileList.length == 0) {
                this.$notify.error(this.$t('请上传充值凭证'));
                return
            }
            const res = await post(apis.submit, {
                image: this.fileList[0].pathUrl,
                ...this.form
            })
            if (res.code == 1) {
                this.form.amount = ''
                this.fileList = []
                this.page.page = 1
                this.recharge()
                this.$notify.success(res.msg);
            }
        },
        //复印
        copyText() {
            const input = document.createElement("input");
            input.value = this.form.address;
            document.body.appendChild(input);
            input.select();
            document.execCommand("copy"); // 执行复制
            document.body.removeChild(input);
            this.$notify.success("复制成功");
        },
        qRCodeS() {
            const parent = document.getElementById(qrcodeID)
            parent.innerHTML = ''
            this.$nextTick(() => {
                new QRCode(qrcodeID, {
                    text: this.form.address, // 二维码内容
                    width: 160,
                    height: 160,
                    colorDark: "#000000",
                    colorLight: "#ffffff",
                    correctLevel: QRCode.CorrectLevel.H
                });
            })
        },
        downloadImagesByParent() {
            const parent = document.getElementById(qrcodeID);
            if (!parent) return console.error('父元素不存在');

            const images = parent.getElementsByTagName('img'); // 获取所有 img
            Array.from(images).forEach((img, index) => {
                const url = img.src;
                const filename = `image_${index + 1}.jpg`; // 自动生成文件名
                fetch(url)
                    .then(res => res.blob())
                    .then(blob => {
                        const blobUrl = window.URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        a.href = blobUrl;
                        a.download = filename;
                        document.body.appendChild(a);
                        a.click();
                        a.remove();
                        window.URL.revokeObjectURL(blobUrl);
                    })
                    .catch(err => console.error('下载失败:', err));
            });
        }


    },
};
</script>
<style lang="scss" scoped>
::v-deep .el-form--label-top .el-form-item__label {
    padding: 0 0 5px 0;
}

::v-deep .el-input--small .el-input__inner {
    height: 40px;
    line-height: 40px;
}

.ewm_img {
    display: inline-block;
    padding: 10px;
    border-radius: 10px;
    background-color: #fff;
}

.tbfh {
    width: 100%;
    padding: 32px 0;
    background: #090d13;
    margin-bottom: 48px;
}

.fjsf {
    cursor: pointer;
    display: flex;
    align-items: center;
    font-size: 1.875rem;
}

.bit-center-wrap {
    width: 1360px;
    max-width: 90%;
    margin: 0 auto;
}

.ted {
    font-weight: 700;
    color: #fff;
}

.box {
    width: 1200px;
    margin: 0 auto;
    color: #000;
    margin-bottom: 50px;

    .bg-main {
        background: none;
    }

    .content_TK {
        width: 480px;
        border-radius: 5px;
    }

    .right {
        width: 480px;

        .tips-back {
            margin-top: 48px;
            border-radius: 10px;
            background-color: #171d28;
            padding: 39px 27px 48px;

            .flex-v-c {
                display: flex;
                align-items: center;
                margin-bottom: 28px;

                .notice-img {
                    width: 24px;
                    height: 22px;
                    margin-right: 10px;
                }

                .fsfs {
                    font-size: 20px;
                    font-weight: 700;
                    color: #fff;
                }
            }

            .content {
                margin-top: 28px;
                font-size: 14px;
                font-weight: 400;
                color: hsla(0, 0%, 100%, .8);
                line-height: 30px;
            }
        }
    }
}

.dad {
    height: 100%;
    display: flex;
    align-items: center;
    color: #07ecfe;
    cursor: pointer;
    padding-right: 16px;
}

.sdafasdf {
    cursor: pointer;
    margin-top: 48px;
    width: 100%;
    background: #f0c163 !important;
    border-radius: 4px;
    border: none;
    font-size: 16px;
    font-weight: 400;
    color: #fff;
    text-align: center;
    padding: 12px 20px;
}

.infosty {
    overflow-y: auto;
    width: 100%;
}

.titlesty {
    height: 64px;
    line-height: 64px;
    border-bottom: 1px solid #2c313e;
    padding: 0 20px;
    color: #fff;
}

.MetaTrader5-bottom-content {
    text-align: center;
    min-height: 250px;
    padding: 20px 20px 0;

    .trend-head {
        height: 65px;
        line-height: 65px;
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 2px;
        color: #fff;
        background-color: #1c222c;
        padding-left: 20px;

        .column {
            flex: 1;
        }
    }

    .scroll-wrap {
        .trend-body {
            .row {
                display: flex;
                align-items: center;
                justify-content: start;
                margin-bottom: 2px;
                font-size: 16px;
                padding-left: 20px;
            }

            .column {
                flex: 1;
                min-height: 69px;
                display: flex;
                align-items: center;
                justify-content: start;
            }
        }

        ol,
        ul {
            list-style: none;
        }
    }

    .bottom-more {
        width: 100%;
        height: 100px;
        line-height: 100px;
        text-align: center;
        color: #888;
    }
}

.bcewm {
    width: 160px;
    text-align: center;
    font-size: 14px;
    padding: 8px;
    margin-top: 16px;
    position: relative;
    margin-bottom: 24px;
    border-radius: 4px;
    background: #293141;
    color: #fff;
}

.bcewm:after {
    content: "";
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 100%;
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 20px solid #293141;
}
</style>